import VueFragment from 'vue-fragment';

export const configureVueFragment = (Vue) => {
  Vue.use(VueFragment.Plugin);
};
